import './style.css';
import { renderLayout } from './components/Layout.js';
import { initRouter } from './router.js';

renderLayout(document.getElementById('app'));
initRouter();
